import React, { useEffect, useRef, useState } from "react";
import Loading from "../../../../Extra/Loading";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import MonthWisePWILoadedEmptyGraph2 from "../GraphView.jsx/MonthWisePWILoadedEmptyGraph2";
import MonthWisePWILoadedEmptyGraph from "../GraphView.jsx/MonthWisePWILoadedEmptyGraph";
import {
  getCurrentFY,
  getDaysInFYMonths,
  getFinancialYearMonthsPassed,
} from "../../../../Utilitie";
import AvgMWPWILEGraph from "../GraphView.jsx/AvgMWPWILEGraph";
import AvgMWPWIHOLEGraph from "../GraphView.jsx/AvgMWPWIHOLEGraph";
import MonthWisePWIHOLoadedEmptyGraphHO from "../GraphView.jsx/MonthWisePWILoadedEmptyGraphHO";
import MonthWisePWILoadedEmptyGraph2HO from "../GraphView.jsx/MonthWisePWILoadedEmptyGraph2HO";

const MonthWisePWILoadedEmptyReport = ({
  PWIdata,
  selectedFy,
  prevPWIdata,
  currPWIdata,
}) => {
  const [loading, setLoading] = useState(false);
  const tableRef = useRef();
  const [selectedRT, setSelectedRT] = useState("Jumbo");

  const getVariationPercent = (prev, curr) => {
    const p = Number(prev);
    const c = Number(curr);
    if (!p && !c) return "0%";
    if (!p) return "∞%";
    return `${(((c - p) / p) * 100).toFixed(1)}%`;
  };

  const monthOrder = [
    // "April",
    // "May",
    // "June",
    // "July",
    // "August",
    // "September",
    // "October",
    // "November",
    // "December",
    // "January",
    // "February",
    // "March",

    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];

  const sortedPrevPWIData = [...prevPWIdata].sort(
    (a, b) => monthOrder.indexOf(a.month) - monthOrder.indexOf(b.month),
  );
  const sortedCurrPWIData = [...currPWIdata].sort(
    (a, b) => monthOrder.indexOf(a.month) - monthOrder.indexOf(b.month),
  );

  const [allMonths, setAllMonths] = useState([...monthOrder]);
  const mpassed = getFinancialYearMonthsPassed(getCurrentFY(), false);
  const [selectedMonths, setSelectedMonths] = useState([...mpassed]);

  const sectionSet = new Set();
  [...sortedPrevPWIData, ...sortedCurrPWIData].forEach((month) => {
    month.data?.forEach((d) => d.section && sectionSet.add(d.section));
  });
  const allSections = Array.from(sectionSet).sort();

  const [selectedSections, setSelectedSections] = useState([]);

  useEffect(() => {
    setSelectedSections(allSections);
  }, [JSON.stringify(allSections)]);

  const getDataBySection = (monthData, section) =>
    monthData?.data?.find((d) => d.section === section) || {};

  const cmdata = sortedCurrPWIData.filter((o) =>
    selectedMonths.includes(o.month.slice(0, 3)),
  );

  const pmdata = sortedPrevPWIData.filter((o) =>
    selectedMonths.includes(o.month.slice(0, 3)),
  );
  const daysCount =
    selectedMonths.length === 0
      ? 1
      : getDaysInFYMonths(
          `${selectedFy.slice(0, 5)}${selectedFy.slice(7, 9)}`,
          selectedMonths,
        );
  return (
    <div>
      <div className="papaDiv">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 ">
          <div>
            <label className="fw-bold me-2 mb-0">Select Sections:</label>
            {allSections.map((section) => {
              const isActive = selectedSections.includes(section);
              return (
                <span
                  key={section}
                  className={`badge rounded-pill px-3 py-2 me-2 ${
                    isActive
                      ? "bg-primary text-white"
                      : "bg-secondary text-white"
                  }`}
                  onClick={() =>
                    setSelectedSections((prev) =>
                      prev.includes(section)
                        ? prev.filter((s) => s !== section)
                        : [...prev, section],
                    )
                  }
                  style={{ cursor: "pointer", userSelect: "none" }}
                >
                  {section}
                </span>
              );
            })}
          </div>
          <div>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => setSelectedSections([])}
            >
              Deselect All
            </button>
          </div>
        </div>{" "}
        <div className="d-flex justify-content-between flex-wrap gap-2 mt-3">
          <div>
            <label className="fw-bold me-2">Select Months:</label>
            {allMonths.map((month) => {
              const active = selectedMonths.includes(month);
              return (
                <span
                  key={month}
                  className={`badge px-3 py-2 me-2 mb-1 ${
                    active ? "bg-success text-white" : "bg-secondary text-white"
                  }`}
                  onClick={() =>
                    setSelectedMonths((prev) =>
                      prev.includes(month)
                        ? prev.filter((m) => m !== month)
                        : [...prev, month],
                    )
                  }
                  style={{ cursor: "pointer", userSelect: "none" }}
                >
                  {month}
                </span>
              );
            })}
          </div>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => setSelectedMonths([])}
          >
            Deselect All
          </button>
        </div>
      </div>
      <div className="d-flex justify-content-between bg-dark text-white p-2">
        <h5>PWI Month Wise Loaded And Empty Report</h5>
        {loading && <Loading />}
        <select
          className="form-select form-control text-center fw-bold"
          style={{ maxWidth: "150px" }}
          value={selectedRT}
          onChange={(e) => setSelectedRT(e.target.value)}
        >
          <option value="Jumbo">Jumbo</option>
          <option value="Boxn">Boxn</option>
        </select>
      </div>
      <div className="row">
        {" "}
        <div className="col-md-12 border border-5">
          <div className="row">
            <h5 className="bg-dark text-white p-2"> AVG PER DAY </h5>
            <div className="col-md-6">
              {" "}
              <AvgMWPWILEGraph
                selectedMonths={selectedMonths}
                selectedSections={selectedSections}
                sortedPrev={sortedPrevPWIData}
                sortedCurr={sortedCurrPWIData}
                selectedRT={selectedRT}
                selectedFy={selectedFy}
              />
            </div>{" "}
            <div className="col-md-6">
              {" "}
              <AvgMWPWIHOLEGraph
                selectedMonths={selectedMonths}
                selectedSections={selectedSections}
                sortedPrev={sortedPrevPWIData}
                sortedCurr={sortedCurrPWIData}
                selectedRT={selectedRT}
                selectedFy={selectedFy}
              />
            </div>
          </div>
        </div>
        <div className="col-md-12 border border-5">
          <div className="row">
            <h5 className="bg-dark text-white p-2">MONTH WISE COMPARISON </h5>
            <div className="col-md-6">
              {" "}
              <MonthWisePWILoadedEmptyGraph
                selectedMonths={selectedMonths}
                selectedSections={selectedSections}
                sortedPrev={sortedPrevPWIData}
                sortedCurr={sortedCurrPWIData}
                selectedRT={selectedRT}
                selectedFy={selectedFy}
              />
            </div>{" "}
            <div className="col-md-6">
              {" "}
              <MonthWisePWIHOLoadedEmptyGraphHO
                selectedMonths={selectedMonths}
                selectedSections={selectedSections}
                sortedPrev={sortedPrevPWIData}
                sortedCurr={sortedCurrPWIData}
                selectedRT={selectedRT}
                selectedFy={selectedFy}
              />
            </div>
          </div>
        </div>
        <div className="col-md-12 border border-5">
          <div className="row">
            <h5 className="bg-dark text-white p-2">SECTION WISE COMPARISON </h5>
            <div className="col-md-6">
              {" "}
              <MonthWisePWILoadedEmptyGraph2
                selectedMonths={selectedMonths}
                selectedSections={selectedSections}
                sortedPrev={sortedPrevPWIData}
                sortedCurr={sortedCurrPWIData}
                selectedRT={selectedRT}
                selectedFy={selectedFy}
              />
            </div>{" "}
            <div className="col-md-6">
              {" "}
              <MonthWisePWILoadedEmptyGraph2HO
                selectedMonths={selectedMonths}
                selectedSections={selectedSections}
                sortedPrev={sortedPrevPWIData}
                sortedCurr={sortedCurrPWIData}
                selectedRT={selectedRT}
                selectedFy={selectedFy}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <div
          className="table-wrapper table-responsive"
          style={{ maxHeight: "700px" }}
        >
          <table
            ref={tableRef}
            border="1"
            cellPadding="8"
            className="table table-striped table-bordered"
            style={{ fontSize: "13px" }}
          >
            <thead className="table-dark text-center align-middle">
              <tr>
                <th rowSpan={4}>Month</th>
                <th colSpan={selectedSections.length * 4}>
                  Previous Year ({selectedFy.replace(/\d+/g, (y) => +y - 1)})
                </th>{" "}
                <th rowSpan={4}>Total T/O L</th>
                <th rowSpan={4}>Total T/O E</th>{" "}
                <th rowSpan={4}>Total H/O L</th>
                <th rowSpan={4}>Total H/O E</th>
                <th colSpan={selectedSections.length * 4}>
                  Current Year ({selectedFy})
                </th>{" "}
                <th rowSpan={4}>Total T/O L</th>
                <th rowSpan={4}>Total T/O E</th>{" "}
                <th rowSpan={4}>Total H/O L</th>
                <th rowSpan={4}>Total H/O E</th>
                <th colSpan={selectedSections.length * 4}>Variation %</th>
              </tr>
              <tr>
                {selectedSections.map((section) => (
                  <th key={`prev-${section}`} colSpan={4}>
                    {section}
                  </th>
                ))}
                {selectedSections.map((section) => (
                  <th key={`curr-${section}`} colSpan={4}>
                    {section}
                  </th>
                ))}
                {selectedSections.map((section) => (
                  <th key={`var-${section}`} colSpan={4}>
                    {section}
                  </th>
                ))}
              </tr>
              <tr>
                {selectedSections.map((_, i) => (
                  <React.Fragment key={`labels-${i}`}>
                    <th colSpan={2}>T/O</th>
                    <th colSpan={2}>H/O</th>
                  </React.Fragment>
                ))}

                {selectedSections.map((_, i) => (
                  <React.Fragment key={`labels-${i}-curr`}>
                    <th colSpan={2}>T/O</th>
                    <th colSpan={2}>H/O</th>
                  </React.Fragment>
                ))}
                {selectedSections.map((_, i) => (
                  <React.Fragment key={`labels-${i}-var`}>
                    <th colSpan={2}>Var T/O</th>
                    <th colSpan={2}>Var H/O</th>
                  </React.Fragment>
                ))}
              </tr>
              <tr>
                {selectedSections.map((_, i) => (
                  <React.Fragment key={`sub-labels-${i}`}>
                    <th>L</th>
                    <th>E</th>
                    <th>L</th>
                    <th>E</th>
                  </React.Fragment>
                ))}
                {selectedSections.map((_, i) => (
                  <React.Fragment key={`sub-labels-curr-${i}`}>
                    <th>L</th>
                    <th>E</th>
                    <th>L</th>
                    <th>E</th>
                  </React.Fragment>
                ))}
                {selectedSections.map((_, i) => (
                  <React.Fragment key={`sub-labels-var-${i}`}>
                    <th>L%</th>
                    <th>E%</th>
                    <th>L%</th>
                    <th>E%</th>
                  </React.Fragment>
                ))}
              </tr>
            </thead>
            {selectedSections.length > 0 && selectedSections.length > 0 && (
              <tbody>
                {selectedMonths.map((monthName) => {
                  const prevMonth = sortedPrevPWIData.find(
                    (m) => m.month.slice(0, 3) === monthName,
                  );
                  const currMonth = sortedCurrPWIData.find(
                    (m) => m.month.slice(0, 3) === monthName,
                  );

                  return (
                    <tr key={monthName}>
                      <td className="fw-bold">{monthName}</td>
                      {selectedSections.map((section) => {
                        const data = getDataBySection(prevMonth, section);
                        const l = selectedRT.toLowerCase();

                        return (
                          <React.Fragment key={`prev-${monthName}-${section}`}>
                            <td>{data?.[`${l}_to_loaded`] ?? "-"}</td>
                            <td>{data?.[`${l}_to_empty`] ?? "-"}</td>
                            <td>{data?.[`${l}_ho_loaded`] ?? "-"}</td>
                            <td>{data?.[`${l}_ho_empty`] ?? "-"}</td>
                          </React.Fragment>
                        );
                      })}

                      <td className="fw-bold bg-light">
                        {selectedSections.reduce((acc, section) => {
                          const d = getDataBySection(prevMonth, section);
                          const l = selectedRT.toLowerCase();
                          return acc + Number(d?.[`${l}_to_loaded`] || 0);
                        }, 0)}
                      </td>

                      <td className="fw-bold bg-light">
                        {selectedSections.reduce((acc, section) => {
                          const d = getDataBySection(prevMonth, section);
                          const l = selectedRT.toLowerCase();
                          return acc + Number(d?.[`${l}_to_empty`] || 0);
                        }, 0)}
                      </td>

                      <td className="fw-bold bg-light">
                        {selectedSections.reduce((acc, section) => {
                          const d = getDataBySection(prevMonth, section);
                          const l = selectedRT.toLowerCase();
                          return acc + Number(d?.[`${l}_ho_loaded`] || 0);
                        }, 0)}
                      </td>

                      <td className="fw-bold bg-light">
                        {selectedSections.reduce((acc, section) => {
                          const d = getDataBySection(prevMonth, section);
                          const l = selectedRT.toLowerCase();
                          return acc + Number(d?.[`${l}_ho_empty`] || 0);
                        }, 0)}
                      </td>

                      {selectedSections.map((section) => {
                        const data = getDataBySection(currMonth, section);
                        const l = selectedRT.toLowerCase();
                        return (
                          <React.Fragment key={`curr-${monthName}-${section}`}>
                            <td>{data?.[`${l}_to_loaded`] ?? "-"}</td>
                            <td>{data?.[`${l}_to_empty`] ?? "-"}</td>
                            <td>{data?.[`${l}_ho_loaded`] ?? "-"}</td>
                            <td>{data?.[`${l}_ho_empty`] ?? "-"}</td>
                          </React.Fragment>
                        );
                      })}

                      <td className="fw-bold bg-light">
                        {selectedSections.reduce((acc, section) => {
                          const d = getDataBySection(currMonth, section);
                          const l = selectedRT.toLowerCase();
                          return acc + Number(d?.[`${l}_to_loaded`] || 0);
                        }, 0)}
                      </td>

                      <td className="fw-bold bg-light">
                        {selectedSections.reduce((acc, section) => {
                          const d = getDataBySection(currMonth, section);
                          const l = selectedRT.toLowerCase();
                          return acc + Number(d?.[`${l}_to_empty`] || 0);
                        }, 0)}
                      </td>

                      <td className="fw-bold bg-light">
                        {selectedSections.reduce((acc, section) => {
                          const d = getDataBySection(currMonth, section);
                          const l = selectedRT.toLowerCase();
                          return acc + Number(d?.[`${l}_ho_loaded`] || 0);
                        }, 0)}
                      </td>

                      <td className="fw-bold bg-light">
                        {selectedSections.reduce((acc, section) => {
                          const d = getDataBySection(currMonth, section);
                          const l = selectedRT.toLowerCase();
                          return acc + Number(d?.[`${l}_ho_empty`] || 0);
                        }, 0)}
                      </td>
                      {selectedSections.map((section) => {
                        const prev = getDataBySection(prevMonth, section);
                        const curr = getDataBySection(currMonth, section);
                        const l = selectedRT.toLowerCase();
                        return (
                          <React.Fragment key={`var-${monthName}-${section}`}>
                            <td>
                              {getVariationPercent(
                                prev?.[`${l}_to_loaded`] || 0,
                                curr?.[`${l}_to_loaded`] || 0,
                              )
                                .replace("-100.0%", "-")
                                .replace("∞%", "-")}
                            </td>
                            <td>
                              {getVariationPercent(
                                prev?.[`${l}_to_empty`] || 0,
                                curr?.[`${l}_to_empty`] || 0,
                              )
                                .replace("-100.0%", "-")
                                .replace("∞%", "-")}
                            </td>
                            <td>
                              {getVariationPercent(
                                prev?.[`${l}_ho_loaded`] || 0,
                                curr?.[`${l}_ho_loaded`] || 0,
                              )
                                .replace("-100.0%", "-")
                                .replace("∞%", "-")}
                            </td>
                            <td>
                              {getVariationPercent(
                                prev?.[`${l}_ho_empty`] || 0,
                                curr?.[`${l}_ho_empty`] || 0,
                              )
                                .replace("-100.0%", "-")
                                .replace("∞%", "-")}
                            </td>
                          </React.Fragment>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            )}
            {selectedSections.length > 0 && selectedSections.length > 0 && (
              <tfoot className="table-dark text-center fw-bold">
                <tr>
                  <td>Total</td>
                  {selectedSections.map((section) => {
                    let sumToL = 0,
                      sumToE = 0,
                      sumHoL = 0,
                      sumHoE = 0;
                    sortedPrevPWIData
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getDataBySection(m, section);
                        const l = selectedRT.toLowerCase();
                        sumToL += Number(d?.[`${l}_to_loaded`] || 0);
                        sumToE += Number(d?.[`${l}_to_empty`] || 0);
                        sumHoL += Number(d?.[`${l}_ho_loaded`] || 0);
                        sumHoE += Number(d?.[`${l}_ho_empty`] || 0);
                      });
                    return (
                      <React.Fragment key={`prev-total-${section}`}>
                        <td>{sumToL}</td>
                        <td>{sumToE}</td>
                        <td>{sumHoL}</td>
                        <td>{sumHoE}</td>
                      </React.Fragment>
                    );
                  })}
                  <td colSpan={4}>-</td>
                  {selectedSections.map((section) => {
                    let sumToL = 0,
                      sumToE = 0,
                      sumHoL = 0,
                      sumHoE = 0;
                    sortedCurrPWIData
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getDataBySection(m, section);
                        const l = selectedRT.toLowerCase();
                        sumToL += Number(d?.[`${l}_to_loaded`] || 0);
                        sumToE += Number(d?.[`${l}_to_empty`] || 0);
                        sumHoL += Number(d?.[`${l}_ho_loaded`] || 0);
                        sumHoE += Number(d?.[`${l}_ho_empty`] || 0);
                      });
                    return (
                      <React.Fragment key={`curr-total-${section}`}>
                        <td>{sumToL}</td>
                        <td>{sumToE}</td>
                        <td>{sumHoL}</td>
                        <td>{sumHoE}</td>
                      </React.Fragment>
                    );
                  })}{" "}
                  <td colSpan={4}>-</td>
                  {selectedSections.map((section) => {
                    let prevToL = 0,
                      prevToE = 0,
                      prevHoL = 0,
                      prevHoE = 0;
                    let currToL = 0,
                      currToE = 0,
                      currHoL = 0,
                      currHoE = 0;

                    const l = selectedRT.toLowerCase();

                    sortedPrevPWIData
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getDataBySection(m, section);
                        prevToL += Number(d?.[`${l}_to_loaded`] || 0);
                        prevToE += Number(d?.[`${l}_to_empty`] || 0);
                        prevHoL += Number(d?.[`${l}_ho_loaded`] || 0);
                        prevHoE += Number(d?.[`${l}_ho_empty`] || 0);
                      });

                    sortedCurrPWIData
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getDataBySection(m, section);
                        currToL += Number(d?.[`${l}_to_loaded`] || 0);
                        currToE += Number(d?.[`${l}_to_empty`] || 0);
                        currHoL += Number(d?.[`${l}_ho_loaded`] || 0);
                        currHoE += Number(d?.[`${l}_ho_empty`] || 0);
                      });

                    return (
                      <React.Fragment key={`variation-total-${section}`}>
                        <td>
                          {getVariationPercent(prevToL, currToL)
                            .replace("-100.0%", "-")
                            .replace("∞%", "-")}
                        </td>
                        <td>
                          {getVariationPercent(prevToE, currToE)
                            .replace("-100.0%", "-")
                            .replace("∞%", "-")}
                        </td>
                        <td>
                          {getVariationPercent(prevHoL, currHoL)
                            .replace("-100.0%", "-")
                            .replace("∞%", "-")}
                        </td>
                        <td>
                          {getVariationPercent(prevHoE, currHoE)
                            .replace("-100.0%", "-")
                            .replace("∞%", "-")}
                        </td>
                      </React.Fragment>
                    );
                  })}
                </tr>

                <tr>
                  <td>Avg/M</td>
                  {selectedSections.map((section) => {
                    let sumToL = 0,
                      sumToE = 0,
                      sumHoL = 0,
                      sumHoE = 0;
                    sortedPrevPWIData
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getDataBySection(m, section);
                        const l = selectedRT.toLowerCase();
                        sumToL += Number(d?.[`${l}_to_loaded`] || 0);
                        sumToE += Number(d?.[`${l}_to_empty`] || 0);
                        sumHoL += Number(d?.[`${l}_ho_loaded`] || 0);
                        sumHoE += Number(d?.[`${l}_ho_empty`] || 0);
                      });
                    return (
                      <React.Fragment key={`prev-total-${section}`}>
                        <td>{(sumToL / pmdata.length).toFixed(2)}</td>
                        <td>{(sumToE / pmdata.length).toFixed(2)}</td>
                        <td>{(sumHoL / pmdata.length).toFixed(2)}</td>
                        <td>{(sumHoE / pmdata.length).toFixed(2)}</td>
                      </React.Fragment>
                    );
                  })}{" "}
                  <td colSpan={4}>-</td>
                  {selectedSections.map((section) => {
                    let sumToL = 0,
                      sumToE = 0,
                      sumHoL = 0,
                      sumHoE = 0;
                    sortedCurrPWIData
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getDataBySection(m, section);
                        const l = selectedRT.toLowerCase();
                        sumToL += Number(d?.[`${l}_to_loaded`] || 0);
                        sumToE += Number(d?.[`${l}_to_empty`] || 0);
                        sumHoL += Number(d?.[`${l}_ho_loaded`] || 0);
                        sumHoE += Number(d?.[`${l}_ho_empty`] || 0);
                      });
                    return (
                      <React.Fragment key={`curr-total-${section}`}>
                        <td>{(sumToL / cmdata.length).toFixed(2)}</td>
                        <td>{(sumToE / cmdata.length).toFixed(2)}</td>
                        <td>{(sumHoL / cmdata.length).toFixed(2)}</td>
                        <td>{(sumHoE / cmdata.length).toFixed(2)}</td>
                      </React.Fragment>
                    );
                  })}{" "}
                  <td colSpan={4}>-</td>
                  {selectedSections.map((section) => {
                    let prevToL = 0,
                      prevToE = 0,
                      prevHoL = 0,
                      prevHoE = 0;
                    let currToL = 0,
                      currToE = 0,
                      currHoL = 0,
                      currHoE = 0;

                    const l = selectedRT.toLowerCase();

                    sortedPrevPWIData
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getDataBySection(m, section);
                        prevToL += Number(d?.[`${l}_to_loaded`] || 0);
                        prevToE += Number(d?.[`${l}_to_empty`] || 0);
                        prevHoL += Number(d?.[`${l}_ho_loaded`] || 0);
                        prevHoE += Number(d?.[`${l}_ho_empty`] || 0);
                      });

                    sortedCurrPWIData
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getDataBySection(m, section);
                        currToL += Number(d?.[`${l}_to_loaded`] || 0);
                        currToE += Number(d?.[`${l}_to_empty`] || 0);
                        currHoL += Number(d?.[`${l}_ho_loaded`] || 0);
                        currHoE += Number(d?.[`${l}_ho_empty`] || 0);
                      });

                    return (
                      <React.Fragment key={`variation-total-${section}`}>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                      </React.Fragment>
                    );
                  })}
                </tr>
                <tr>
                  <td>Avg/D</td>
                  {selectedSections.map((section) => {
                    let sumToL = 0,
                      sumToE = 0,
                      sumHoL = 0,
                      sumHoE = 0;
                    sortedPrevPWIData
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getDataBySection(m, section);
                        const l = selectedRT.toLowerCase();
                        sumToL += Number(d?.[`${l}_to_loaded`] || 0);
                        sumToE += Number(d?.[`${l}_to_empty`] || 0);
                        sumHoL += Number(d?.[`${l}_ho_loaded`] || 0);
                        sumHoE += Number(d?.[`${l}_ho_empty`] || 0);
                      });
                    return (
                      <React.Fragment key={`prev-total-${section}`}>
                        <td>{(sumToL / daysCount).toFixed(2)}</td>
                        <td>{(sumToE / daysCount).toFixed(2)}</td>
                        <td>{(sumHoL / daysCount).toFixed(2)}</td>
                        <td>{(sumHoE / daysCount).toFixed(2)}</td>
                      </React.Fragment>
                    );
                  })}{" "}
                  <td colSpan={4}>-</td>
                  {selectedSections.map((section) => {
                    let sumToL = 0,
                      sumToE = 0,
                      sumHoL = 0,
                      sumHoE = 0;
                    sortedCurrPWIData
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getDataBySection(m, section);
                        const l = selectedRT.toLowerCase();
                        sumToL += Number(d?.[`${l}_to_loaded`] || 0);
                        sumToE += Number(d?.[`${l}_to_empty`] || 0);
                        sumHoL += Number(d?.[`${l}_ho_loaded`] || 0);
                        sumHoE += Number(d?.[`${l}_ho_empty`] || 0);
                      });
                    return (
                      <React.Fragment key={`curr-total-${section}`}>
                        <td>{(sumToL / daysCount).toFixed(2)}</td>
                        <td>{(sumToE / daysCount).toFixed(2)}</td>
                        <td>{(sumHoL / daysCount).toFixed(2)}</td>
                        <td>{(sumHoE / daysCount).toFixed(2)}</td>
                      </React.Fragment>
                    );
                  })}{" "}
                  <td colSpan={4}>-</td>
                  {selectedSections.map((section) => {
                    let prevToL = 0,
                      prevToE = 0,
                      prevHoL = 0,
                      prevHoE = 0;
                    let currToL = 0,
                      currToE = 0,
                      currHoL = 0,
                      currHoE = 0;

                    const l = selectedRT.toLowerCase();

                    sortedPrevPWIData
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getDataBySection(m, section);
                        prevToL += Number(d?.[`${l}_to_loaded`] || 0);
                        prevToE += Number(d?.[`${l}_to_empty`] || 0);
                        prevHoL += Number(d?.[`${l}_ho_loaded`] || 0);
                        prevHoE += Number(d?.[`${l}_ho_empty`] || 0);
                      });

                    sortedCurrPWIData
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getDataBySection(m, section);
                        currToL += Number(d?.[`${l}_to_loaded`] || 0);
                        currToE += Number(d?.[`${l}_to_empty`] || 0);
                        currHoL += Number(d?.[`${l}_ho_loaded`] || 0);
                        currHoE += Number(d?.[`${l}_ho_empty`] || 0);
                      });

                    return (
                      <React.Fragment key={`variation-total-${section}`}>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                      </React.Fragment>
                    );
                  })}
                </tr>
              </tfoot>
            )}
          </table>{" "}
          {(selectedMonths.length === 0 || selectedSections.length === 0) && (
            <div className="text-danger fw-bold">
              {" "}
              Please Select Months And Section
            </div>
          )}
        </div>
        <DownloadExcel
          tableRef={tableRef}
          fileName={` PWI Month Wise Loaded And Empty Report - ${selectedFy} ${selectedRT} `}
        />
      </div>
    </div>
  );
};

export default MonthWisePWILoadedEmptyReport;
